import * as React from "react";
import type { SVGProps } from "react";
const SvgBhutan = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <defs>
      <style>
        {
          ".Bhutan_svg__cls-3,.Bhutan_svg__cls-7{fill:#fff}.Bhutan_svg__cls-3,.Bhutan_svg__cls-4,.Bhutan_svg__cls-5,.Bhutan_svg__cls-6,.Bhutan_svg__cls-7{stroke:#000;stroke-width:.5px}.Bhutan_svg__cls-4,.Bhutan_svg__cls-5,.Bhutan_svg__cls-6{fill:none}.Bhutan_svg__cls-5,.Bhutan_svg__cls-6,.Bhutan_svg__cls-7{stroke-linecap:round}.Bhutan_svg__cls-6{stroke-linejoin:round}"
        }
      </style>
    </defs>
    <g id="Bhutan_svg__Bhutan">
      <path
        d="M.65-.23h1278.7v720.47H.65z"
        style={{
          fill: "#efb22d",
        }}
      />
      <path
        d="M.65 720.23h1278.7V-.23Z"
        style={{
          fill: "#e23d28",
        }}
      />
      <path
        d="M639.11 225c-6-2.13-9.85 1-9.66 8.7s4.26 12.18 10.24 9.28Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M644.38 210.54c-5-3.94-9.64-2.25-12 5.14s.12 12.89 6.72 12.07Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M652.68 196.52c-4.3-4.68-9.16-3.76-12.62 3.16s-1.95 12.75 4.7 13ZM647.23 264.65c-7.34 2.7-8.12 12.75-3.47 18.94s13.14 7.35 17.78 0Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M638.73 243.38c-7-2.32-13.23 7-14.31 15.47C623.07 269.48 608 273 616.31 289c1.74-10.24 8.51-15.85 13.91-16.24s13.54-1.54 17-8.11ZM660.77 284.75c-8.12 1.93-9.28 12.76-3.48 20.49 5 6.62 20.48 5 20.1-1.55ZM683.77 349.89c.38-7-10.82-9.66-16.24-8.31s-15.75-.19-18.17-6c-1.93 4.64.87 9.66 8.7 12.18 5.93 1.9 5.8 6.18 4.06 8.11 4.45.79 17.59.79 21.65-5.98Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M677.39 305.43c-7.93-3.48-12.62 1.82-15.66 7-4.44 7.54-18.17-2.12-22.81 7.93 6.29-2.71 12.68 3.06 15.66 5 8.5 5.61 24.94 3.87 27.26-9.28Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M682 314.71c-7.93 6-11 13.15-10.82 18s6.95 15.46 14.3 16c4.28-8.71 6.41-27.04-3.48-34ZM649.17 352c0-2.9 4.25-4.06 7.15-3.1s7.35 3.87 5.8 7ZM605.48 336.17c-.77-3.48 4.84-9.47 12.38-6.19s8.5 9.67 5.4 12.18Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M623.84 342.55c-.58-1.94 4.85-5.8 14.12-3.48s11.55 8.29 11.21 12.95ZM604.52 336.17c4.83-3.68 3-10.64-1.36-12.76-7.92-3.87-5-13.92-10-15.85s-9.86-5.41-10.05-8.89c-2.51 4.83-1 9.28 2.51 12.37s-2.7 15.66 1.74 18.94ZM500.91 333.46c-4.06-6.38-13.73-5.22-17.79-.77s-3.48 11 .39 13.92Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M524.1 324c-1.54-8.51-11.79-9.47-17.39-7.35s-9.48 10.64-5.8 16.82Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M539.57 322.83c3.67-7.15-3.48-17.78-11.6-19.33-6.78-1.29-14.79-1.26-17.4-7.93-1.64 5.8 2.71 9.48 7.73 12.76s-1 11.79 7.16 16.63Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M538.79 323.08c-1.69-5.13 1.74-11.94 8.69-11.47s10.9 5.53 7.84 11.84Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M554.26 323.46c-1-5.31 3.4-11.57 10.21-10.13s10 7 6.1 12.82Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M569.61 325.9c-.69-5.35 4-11.39 10.7-9.61s9.66 7.5 5.45 13.11ZM453 414.45c-13 0-16.12 3.09-18 16.43-2.33 16.63 20.29 18.56 18-16.43Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M458.77 397.06c-19.91-7.54-30.74 24-50.45 18.36 7.05 11.21 24.15 0 30.54 1.16 10.82 1.93 34.21-2.13 19.91-19.52ZM445.82 440.16c-9.86-4.44-20.49 10.63-18.56 17.21 2.45 8.34 24.94 1.54 18.56-17.21ZM399.81 505.11c5.41 1.55 12 4.64 10.83 15.08s-20.88 31.7-38.66 32.86-24.17 22.61-39.44 16.62c14.31-2.7 14.31-18.94 25.52-24-8.12-2.91-12.37 15.46-22.81 15.46s-15.46 16.66-28.25 15.5-14.1 20.24-39.63 20.49c-19.52.19-43.68 23-52.38 13.15 18.94-2.71 26.58-13.21 37.88-24.75 18.17-18.55 38.66-10.24 45.62-26.67a47.5 47.5 0 0 1-27.42 8.15c-11.89-.25-24.93 18.94-38.27 10.44 7.73-1 12.76-4.26 20.88-12.76 8.31-8.71 20.51-3.08 30.15-12 15.08-13.91 28-2.32 42.53-19.71-4.06-1.93-12.76-.58-20.88 3.67s-18.56-2.9-27.83 2.13c1.16-11.41 22.81-4.88 36.34-12.76 15.27-8.89 27.93-6.29 40-5.22-16.82-.1-23.39-16-46.59-11.41-10.11 2-18.17-13.91-28.22-5.8.29-6 10.83-10.82 21.65-5s15.19-5.07 36.73 8.51c8.89 5.6 24.16-3.49 33.83 2.51-1.26-3.68-6.77-6-13.24-5.51 4.07-8.35 30.26-7.29 41.66 1.02Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M417 492.55c-8.51-6.58-20.3 1.35-28.42-1.74 0 5.41 2.71 13.53 11.6 16.62 2.72-1.93 14.9-12.56 16.82-14.88Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M430.35 473.8c-13.35-6.8-15.65 10.05-26.09 6.57.38 4.83 4.25 10.82 12.76 12.18Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M438.28 458.53c-19.72-7.74-22.23 11.21-33.83 7.53 2.71 6.58 19.33 10.06 27.84 7.74ZM465.34 375.6c-5.22-7.34-16.24-1.35-18 7.35s2.52 20.87 9.86 18.17Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M478.68 352.4c-9.09-2.12-19.53-1.16-18.37 7.74-3.48 1.54-4.44 12.95 5 15.46Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M484.67 346.41c-8.89-10.44-18.81-10.19-24.36-5.8-10.24 8.12-20.2 3.48-20.49 11.6 6.19-4.73 11.6 1 16.63-.77s8.7 7.92 22.61 3.86ZM463.21 502.41c1.36 2.51 9.67 3.67 13.73-.58 5.38-5.64-.58-21.27-9.09-22.43s-9.28 17.6-4.64 23.01Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M453.55 502.79c12.18 4.45 17.4-5.61 10.82-12-1.74 2.14-8.12 9.88-10.82 12Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M407.93 519.41c-2.32 7-14.3 8.12-27.83 29.77s-26.49 12.57-29.77 27.45c16.23-13.14 29-4.41 38.66-17.4 14.69-19.71 26.79-16.88 32.47-30.15 8.12-18.94 43.69-18.56 45.62-48.32-11.98-2.32-49.87 29.76-59.15 38.65ZM713 227.15c15.46 5 15.85 25.13 33.63 31.7s19.53 22.42 34 18.55c-13.53-3.67-12.56-19.33-26.67-23.19-16.55-4.54-22.81-29.77-36-33.64M783.9 332.11c2.71 6.18 2.32 17.2-7.35 20.1 5.22 3.29 13 .19 17.2-7-6.37 14.11-2.12 26.87 7.93 29.38-4.83-9.85 6-14.49 2.52-20.87 6.38 2.7 12 11.4 11.78 16.81 8.32-9.27-6.18-21.65-3.47-30.34ZM683.77 431.46c-9.47-8.31-13.52 2.18-18.17-1.45-4.35-3.38-10.15-3.86-12.37-.48 8.12.29 4.15 6.57 19.91 8.12-15.76 1.06-12.86 18.65-23.39 17.78 11.21 10.63 17-9.47 26.09-6.18-2.7.77 4.26 7.15-.58 15.65 7.83-.19 11-11 12-16.62ZM475.2 521.73c-3.48-2.89-13.53-4.25-17.4-1.93s-2.51 2.9 2.13 3.29 10.63 7.89.58 8.31c-4.64.19-3.09 11.4-12.76 12.18 4 4.83 15.27 1.64 19.33-3.67-.77 4.34 5 8.31 2.71 13.53 7.15.77 3-14.5 14.3-13.73-4.64.58-2.71 11 5.41 8.31-4.83 2.32-2.32 7.93 3.1 6.58-3.48 1.16-4.64 5.6.19 8.12 4.64-6.38-.58-29.19-17.59-40.99ZM896.21 308.45a26.79 26.79 0 1 0-26.8-26.79 26.79 26.79 0 0 0 26.8 26.79Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M756.26 340.81c8.12-7.74 20.49-11.6 29-5.8s36.74 12.76 50.64 3.09 20.49-14.69 26.67-13.53c4.64 7 10.25 10.24 17.21 10.82 2.12 2.32 9.66 4.26 13.91 3.68 6.19 1.54 13.73-.39 19.72-7 9.28 1.35 18-5.61 21.26-16.05 9.86-1.16 10.44-12.17 4.25-19.52-5.79-1.16-1.35-20.68-22.42-16.82 8.9 5.42 2.13 16.24 9.48 21.27-5 0-11.51 2.12-13.05 9.66 1.93-5.22-.29-8.7-1.65-9.86.2-4.44-9.66-15.36-18.94-11.4 6.67 1.45 2.9 12.18 7.73 16.24a12.22 12.22 0 0 0-9.28 5c-2.51-4.44-11.4-9.08-16.81-9.47a19.6 19.6 0 0 0-1-6.19c-2.42-4.63-4.45-10.14-3.48-17.2-4.64 5-8.51 12-10.82 17-7.35-5-25.52 2.32-34 4.25s-37.12-2.7-43.69-9.66-19.33-11.21-31.31-14.69c-16.48-4.78-16.63-22.81-34.8-35.18-.38 22.49 33.65 93.62 41.38 101.36ZM566.82 511.68a25.9 25.9 0 1 0-25.9-25.9 25.89 25.89 0 0 0 25.9 25.9Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M505 491.77c5.22 6.77 14.11 6.38 17.78 5.8 3.09 8.12 13 7.93 17.2 12.37s18.75 4.06 23 1.55c-3.86-.39-8.88-2.7-13.72-6.77-5.83-4.89-3.09-14.69-7.73-18.17 3.48-3.86 4.06-10.24 3.29-12.75 3.67-2.13 6.38-5.61 6.76-7.35 6.38-.39 12-3.67 14.31-6.18 3.28 3.09 11.59-1 16 4.25 1-12.76-11.21-19.53-19.33-15.27-3.29-1.74-12-.58-13.53 1.74-2.71-1.16-10.25 2.7-13.73 5.22 3.87-2.13 4.45-8.51 2.9-10.83 3.29-1.35 7-5.8 7.35-9.08 4.64.77 11.6-2.32 14.69-1.55-5-6.57-13.34-8.89-21.84-8.31-8.8.48-12.57 6.67-13.73 13.34-5.22 3.09-7 13.53-5 17.2-3-.1-5.8 2.8-7 4.45a40.1 40.1 0 0 0-14-3M500.52 447.89c-1.74-5 .57-9.55 1.74-13.53 3-10.14 1.16-12.75-7.92-11.4-.78 4.83 3.86 20.68 6.18 24.93Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M493.85 423.54c2.32 2.32 10.54 3.38 11.41-4 1-8.44-2.42-11.7-9.77-8.41-.57 1.97-1.25 9.87-1.64 12.41Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M495.59 410.88c3.09 1.25 9.76 3.77 13.44-3.38 3.08-6-1-10.64-7.35-10.25-1.55 1.75-4.68 7.93-6.09 13.63Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M501.29 396.67c.78 2.32 8.7 10.05 14.5 4.45s5.8-13.92-2.9-17c-2.32.37-9.28 8.49-11.6 12.55Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M512.89 384.11c1.74 4.83 7.15 13.14 17.21 9.27s5.79-16.43 1.16-18.94c-2.71.19-13.73 5.22-18.37 9.67Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M531.26 374.44c-.78 4.25 0 15.85 13.72 15.66s9.86-16.24 6.38-18.56c-5.61 0-15.08.19-20.1 2.9Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M551.94 372.12c-1.55 3.29-5 24.92 21.84 18.94 3.48-.77 12.56-20.68-21.84-18.94Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M566.63 374.05c-2.7 2.71 4.25 24.55 22.42 20.88s2.95-24.36-22.42-20.88Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M582.09 377.34c-2.89 6 1.46 23.78 23.88 23.78 20.32 0-1.07-23.39-23.88-23.78Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M599.68 382.56c-1.45 3.32-3.23 22.17 23.2 23.78 19.12 1.16 14.5-25.91-23.2-23.78Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M628.1 390.48c-3.28 5.8-6.77 20.3 22.23 21.46 18.57.74 7.15-21.07-22.23-21.46Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M652.26 394.93c-4.25 5.8-1.12 17.17 9.66 19.33 13.54 2.71 15.47-10.05 6.19-16.24s-15.85-3.09-15.85-3.09Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M665.41 397.64c-3.1 5.41-1.18 18.55 19.32 18.55 4.27 0 20.5-16.62-19.32-18.55ZM506.71 649.72a30.08 30.08 0 1 0-30.07-30.07 30.07 30.07 0 0 0 30.07 30.07Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M727.26 212.46c-2.32 2.32-7.15 9.27-8.12 12-10 30.15 16.78 52.68 32.48 85.05 12.37 25.52 10.82 65.72-8.51 91.24-6.61 8.73-4.64 11.21-13.14 20.1-3.26 3.41-7 7.73-5.8 20.11 5.41-1.94 13.14 3.09 14.69 7.34 3.87-1.93 9.28-1.16 11.21 1.16 6.57-3.09 12-1.55 17.78 4.64a16.33 16.33 0 0 1 15.47 5.41c2.7-5.41 8.12-7.34 12-6.18-.38-7 6.58-12 12.76-9.28a11.43 11.43 0 0 1 14.69-13.53c7-5.41 20.88-5.8 27.84 2.32-12.38-3.48-12 9.66-22.43 8.5 2.71 7.73-4.25 12.18-11.21 14.69 4.45-2.12 9.28-4.64 10.83-1.93 3.86-3.38 11.59-2.13 13.53-.39 5.12-1.64 10.05-.38 12.37 5.8 7 4.26 11.6 15.08 6.57 23.2-1.54-8.51-7.34-8.12-9.66-11.6-5.42 1.93-10.83 1.93-12.38-1.55-3.09 3.1-13.52 5.8-18.16 1.16-1.74 7-7.74 12.76-14.7 12.76 1.94 5.41-3.47 14.69-7.73 19.33 6.58 3.48 4.64 11.21 3.09 15.85 10.06 1.55 1.55 10.44 18.95 16.24-8.5 2.71-25.13 0-27.45-10.44-8.51-.38-14.31-8.89-13.92-17.78-6.57-6.19-7.54-15.08 1.55-21.27-7.73 2.32-12-10.05-23.2-5-5.57 2.5-20.29-1.74-20.1-7-2.32 3.87-16.43 2.32-18.36-4.25-4.64 2.51-15.47-1.74-15.27-8.12-6 2.71-14.11-2.13-13.73-8.31-5.6-.78-6.18-5.8-5.8-10.05-5-2.32-3.67-7.16-1.74-13-3.48-3.86-1.93-9.27.78-14.3-3.87-3.87-3.09-8.5-1.94-13.92-18.56-1.54-41.8-6-95.1-22.42-80.4-24.7-102.08 33.29-84.3 69.63 20.52 41.93-2.32 51 4.64 82.35a13.38 13.38 0 0 1 10.83 14.3c4.34.19 7.44 4.25 5.89 12a13.47 13.47 0 0 1 11.5 3.48c2.71-5 11.6-6.18 16.24-.39 10-.77 15.08 7.35 14.69 17.4 5.41 9.67 3.48 21.46-2.32 29 .58-4.06 0-9.86-.19-13.34-.36-6.4-9.28-7.73-8.31-13-4.64.38-9.09-2.13-10.64-5.61a10.19 10.19 0 0 1-9.85 1.94c5.21 2.32 9.27 11.59 7.73 17.78 2.7 4.64 2.12 13.15-1.16 16.82-1.55 7.53-7.35 10.24-14.89 7 4.26-2.7 5.8-7.53 5.61-11.59-2.71-2.32-4.06-6.77-4.25-9.48-7.54 1.16-18-5.21-19.91-7.74a30.08 30.08 0 0 0-30.07 30.08c-.77-6.19-8.59-12.28-7.63-17.5-4.64-14.31 1.94-27.65 20.88-30.35-2.32-5.41 5.8-11 2.71-17.2-4-7.9-11.22-18.18-22-30.16 6.57-11.21 4.64-26.29.77-35.57-5.55-13.32-10.82-10.05-30.54 11.6-32.13 35.28-75 25.52-112.89 48.71-10.06 6.17-20.1 8.51-9.27-2.31s39.43-21.65 58-30.93c34.75-17.38 64.17-46.4 75.77-102.84 27.25-132.64 127.58-88.92 191-64.18 59.52 23.24 48.71-29.38 18.55-61.08-36.24-38.1-29-68-12-92 30.49-4.28 89.06 6.35 77.27 16.6Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M834.94 538.3a33.09 33.09 0 1 0-33.09-33.09 33.08 33.08 0 0 0 33.09 33.09Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M708.7 214c-7.34 32.48-1.16 47.17 9.67 61.47 22.37 29.57 40.21 97 14.69 141.11"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M747.36 378.5c3.1-1.16 8.9-4.83 10.25-11.21M749.69 364.39c1-5.61 9.66-8 9.85-14M749.88 342.55c-.58-5.8 8.7-11 7.34-16.82M744.85 321.67c-.77-3.29 7.73-9.47 5.42-14.69M738.47 301.37c-1.74-3.67 4.06-7.92 1.55-11.79M729.19 285.14c-.58-2.52 3-8 1.07-11.31M719.92 266c.77-1 3.86-3.29 2.6-6.19M713.54 252c1.25-.68 5-1.84 4.54-4.64"
        className="Bhutan_svg__cls-5"
      />
      <path
        d="M520 616.45c-7.73-2.71-17.39 1.16-19.33 7.74M506.51 630.18c1-6.57 11-9.48 14.11-6.38-6.37-3.48-9.47 8.89-3.86 9.28M568.75 477.28c-4.63 2.32-6 10.82 0 17.2M575.71 479.21c-3.28 2.71-3.09 10.82 1.74 12.76-4.05-2.9 0-7.93 2.91-8.12s4.82 3.28 1.35 6.76M847.3 498.34c-10.82-2.89-19.52 9.67-9.67 20.88-.19-10.82 7.54-18 17-16M850.3 510.67a4 4 0 0 0-4.16 4.11c0 2.12 1.84 4.15 4.83 4.15 1.94 0 3.48-2.22 3.48-4M888.47 273.34c1.74 6.58 10.83 9.28 18 7.74M906.45 276.82c-5.61.2-10.24-5-9.86-9.47 0 3.29 7.54 4.84 9.86 2.71"
        className="Bhutan_svg__cls-6"
      />
      <path
        d="M522.75 497.57c-1.55-3.86 4.64-7.73 4.83-11.4s7-6.57 13.92.38M538.21 445.38c-1.35.58-2.51 1.35-3.67 1.74M551.55 466.45c-1.64.1-5-.09-6.86-1.35M544.79 473.8a35.7 35.7 0 0 1-6.09 2.2M478.48 590.55c-.19 3.48 3.29 8.51 5.22 10.05M493.56 582.24c-1.93 2.9-3.09 7.92-1.93 11.4M522.36 593.84c-3.48-2.32-1.16-8.32-1.54-12.18s4.06-10 12.76-4.83M489.89 571.8c3.48-.58 7.15-.39 9.47.58M534 560.78a12.54 12.54 0 0 0-2.12 6M550.2 560.39a7.68 7.68 0 0 0-6.19 3.87M512.7 461.43c3.09 1.06 11.11 6 11.4 11.11M545.56 436.3c-9.47-.2-13.14-9.86-6-9.86M562.57 449.25c-3.67 1.54-1.93 7.92 3.29 11M540 509.94c-1.83-2.31.58-9.08 6.58-7.05M554.07 580.5c.38-5.9 7.82-9.38 10.82-2.71M526.62 597.31c-.49-6.47 2.8-8.6 5.7-9s7 2 9 6.28M469 602.15c.39-3.87 3.68-7.93 7.15-7.35M822.75 430.5c-2.51 1.83-4.15 10.05 5.41 10.82M808.06 444c0 1 1.25 2.32 2 2.9M853.68 459.49c-2.51-1.93-9 5.9-3.09 11.6M792.21 524.44c-1.45-5.51 3.67-7 8.5-5.8M779.84 485.39c2.9-1.93 5.8-4.05 9.47-5M778.29 506.66c0-4.64 2.32-8.51 4.45-9.67M795.3 453.31c-.38 5.6 1.94 11 3.68 13.91M841.31 453.69c-2.81.87-5.32 1.94-6.38 4.26M838.21 469.54a24 24 0 0 0 3.58-3.48M911.28 300.79c0 5.42-6.76 8.32-11.21 4.84M926 301c3 2.32 13.33.09 10.91-5.9M913.41 332.11a15.9 15.9 0 0 1-7.35-4.64M934.67 316.06a11.2 11.2 0 0 1-7.54-.77M879.78 335.39a26 26 0 0 0 9.76-2.41M874 301.18a8.26 8.26 0 0 0-5.8 1.16M912.93 310.65c-.68 2.42-2.42 6.19-4.55 7.83"
        className="Bhutan_svg__cls-5"
      />
      <path
        d="M867.4 319.16c4.84-2.13 10.83 14.3 22.43 8.5M890.79 310.65a17 17 0 0 0-2.7 8.31"
        className="Bhutan_svg__cls-6"
      />
      <path
        d="M659.61 285.52c1.54-.19 4.25-.77 4.83-2.7M460.7 465.48c5.8 3.29 9.86 8.9 7.35 17.21M726.49 267.74c1.74 1.16 8.31 1.16 12-.19M743.11 271.61c-.19 2.7.58 12.95-4.64 15.07"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M740.41 285.33c4.83 1.55 14.49 1 17.59-7.93"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M751.23 284.94c2.51 3.87 3.28 11.41-4.25 15.47"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M753.16 291.32c5.61 1.93 18.56 2.13 17.2-8.89"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M765.92 291.32c3.87 5.41 20.88 11.79 18.17.58M750.27 307c6.57 1.55 15.85-2.9 12-14.5"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M780.81 298.28c1 4.45 22.61 9.09 19.71-1"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M796.46 303.11c4.06 9.28 25.52 8.51 18.75-3.86"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M811.73 308.91c4.25 5.22 23.2 2.13 15.66-10.44"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M827.2 308.72c11.79 8.89 25.51-3.87 10.63-13.15"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M844.59 305.82c10.44 8.31 23.2-6.77 14.12-11M762.05 302.34c3.29 1 10.25.58 11.8-5.41"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M771.24 301c-.39 8.79 14.4 12.17 18.17 2"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M784.48 308.53c2.71 5.79 15.65 8.11 17.78-.2"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M800.13 312.2c2.13 5.8 13.34 5.22 16.43-.77"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M812.51 315.29c3.47 7.54 17.78 7.54 21.07-3.48"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M831.06 316.64c5.61 3.48 17.6 2.13 16.62-8.69"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M845.37 315.68c8.31 6.76 20.1.19 14.3-11.21"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M859.09 324.57c4.45-.77 6.77-9.67 2.13-12M756.07 326.12c9.27-5 11-13.54 4.63-21.85"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M764 317.61c5.8 3.48 16.82-.19 18.75-8.7"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M771.92 318.58c3.28 4.25 3.86 9.47-.39 14.3"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M774.62 324c10.24-6.38 23 5.41 13.53 12.56"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M786.41 323.41c2.32-.58 6.38-4.83 6.76-9.67M791.05 327.86c4.25-4.45 33.25 4.63 14.88 13.91"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M804.58 315.68c5.61 2.12 8.51 10.05 0 12.76M811.93 335c6.18-6.38 25.51-2.32 18.55 5.8"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M825.85 332.49c3.47-11.79 24.16-4.44 17.39.39M821.59 320.7c.58 2.32.77 8.12-3.09 11.21"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M839 318.38a9.23 9.23 0 0 1-1.16 7.93M852.13 318.58c1.16 2.12 3.09 6.18-1.16 9.47M686.67 229.66c.19 11 4.06 18.36 18.94 11.4"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M691.31 242.8c-7.35 9.86 1 20.49 15.46 9.86"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M668.69 247.64c10.06 10.82 28 2.9 16.43-13.54M697.3 256.91c-1.93 10.64 6.77 12.76 13.92 7.93M659.8 249.38c1.83 10.68 12.76 19.13 23.39 12.56"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M673 264.07c0 15.27 21.06 17 25.9 1.16"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M691.31 274.89c6.76 13.92 21.45 8.31 26.29-.19M676.42 252.66c2.71 6.77 8.12 14.31 20.69 8.7M637.76 249.38c1.74 5.6 11.8 12.37 23.39 4.63"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M644.92 256.53c-6.19 9.08 6.18 17.59 21.07 4.06"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M652.26 267.74c2.51 12.76 7.54 23 25.71 6.57"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M668.88 280.88c6.58 8.12 16.63 13.15 26.1-.58M701.94 283.2c-.58 9.67 1.35 14.5 8.89 14.11 5.94-.3 11.6-5 14.89-10.05"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M709.48 297.31c-.2 11 8.5 19.72 24.74 8.51"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M716.24 310.27c-3.09 8.31 6.19 21.84 24.36 14.88M677.77 288.23c-1.15 10.63 8.71 17.78 24.56 4.06"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M685.51 300c.58 8.7 10.44 19.14 24.94 4.06"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M692.47 311c-1.16 14.88 12.56 19.13 24.16 7.73M671.79 300c3.09.19 5.6-2.51 7.15-4.45M678.35 310.85c2.71.58 7.35-1.94 8.9-5"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M685.12 328.44c3.1 3.28 13.53 1 14.88-3.48"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M696.72 328.24c5.8 13.53 21.26 12.95 27.64-2.32"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M721.46 331.34c2.9 7.92 10.25 13 22.23 10.24"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M727.26 339.45c-6.76 11 2.13 24 17.2 11.21"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M730.93 355.88c-.77 7 5.61 14.89 14.31 15.85M702.33 335.59c-2.33 15.65 8.89 23.19 23 14.88"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M685.89 343.13c3.68 2.9 10.25 3.28 16.44 1M709.87 353.18c-3.49 13.14 10 22.61 21.64 7.92"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M691.11 345.25c.2 6.77 6.77 14.11 18.17 12M741.18 370.77c-7.73 5.22-9.28 14.5 1.55 20.49"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M722.23 368.06c.39 7.93 4.07 12.37 12.76 13.15"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M710.83 364c-11.6 10.63-.19 23 13.53 12.57"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M719 379.85c-3.87 12.18 10.63 19.53 18.36 7.16M695 354c-4.25 12 1.16 19.91 11 19.14"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M679.71 351.63c.58 7.15 6.77 9.67 13.72 8.12"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M684.15 359.17c-5.21 10.05 2.71 15.46 13.15 11.6M729 393.19c-1.74 6.38-.77 11 8.7 13.15"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M729.58 402.28c-11.4 5.22-12.37 16.23-3.48 23.38"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M720.4 390a11.41 11.41 0 0 0 1.74 18.46M669.66 354.72c-6.58 6.48-.29 24.36 14.2 14.6"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M707.35 377.34c-8.89 7.35-4.83 20.68 9.86 17"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M692.66 371.73c-4.64 13.15-.19 17.79 10.25 18M660 354.14c-7.92 6-5.8 14.5-2.31 18.37s10 2.12 12.17-2.9"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M643.37 348.92c-8.89 11.41 0 24.94 12.57 20.88M690.92 382.75c-9.08 3.29-16 11.54-10.44 18.75 3.29 4.26 17.59 4.84 21.65-11.6"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M674.49 372.12c-5.22 7.54-3.48 14.69 6.19 18.36"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M673.91 386.23c-5.61 3.09-9.28 6.77-7.92 13.53"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M661.35 374.44c-2.13 9.09.38 14.69 6 17.4"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M661.15 385.27c-8.7-.58-13.14 3.09-10.24 11.59"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M651.68 387.39c-8.5-3.09-9.86-10.44-6.19-18.17"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M644.34 380.63c-9.28.38-13.34 5-13.34 11.4M631.77 344.48c-6.76 2.9-8.89 12-6.38 17s10.44 5.41 15.28 2.13"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M612.83 337.33c-6.19 7 1 20.49 12 17.2"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M597 331.91c-5.8 8.12.58 21.65 15.46 17.79M613.21 387.39c-1.54-9.66 8.51-16 20.88-3.48"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M628.1 364.39a15.17 15.17 0 0 0-4.84 12.76M581.13 327.28c-6.38 10.82 1.35 20.68 15.08 16.81M616.89 354.14c-9.09 9.09-6 18.17.77 23.39"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M611.09 364.78c-13.73.19-14.5 16-3.29 21.07"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M600.65 348.92c-5.6 3.87-7.35 14.5 2.32 18.76M600.26 372.7c-5.79-2.71-12.75.58-12.17 7.35"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M591.56 372.89c-5.22-12.37-20.48-10.24-19.13 2.52"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M595.82 357.62c-3.29.58-9.86 2.52-12.37 7.54"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M584.41 343.71a10.57 10.57 0 0 0 3.68 17M566.05 324.18c-1.16 8.31 2.13 12.37 12.56 11.6"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M569.72 334.81c-4.06 10.06 1.36 14.5 11.79 13.92"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M572 347.19c-6.18 7.34-1.93 15.27 4.06 18.55"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M569.14 356.46c-11-1.35-12.75 11.41-9.08 17.4M560.25 323.22c-6.76 2.9-10.63 11.4-7 16.62s11 3.48 15.08.77"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M555.61 342.16c-5.6 8.5-.58 14.88 5.41 17.4M534 322.25c-4.44 4.64-1.74 14.11 9.09 14.3 8.71.16 13.14-8.11 10.44-13.91"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M541.5 336.55c-3.48 7.74-1.35 16.05 11.79 14.69M558.9 363.42c-8.12-3.67-18.95 0-14.31 9.67"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M543.43 349.7c-3.28 4.64-2.12 11.21 1.55 15.27"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M542.85 362.07c-5.41 1-10.63 3.87-7.34 12.37"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M534.73 367.48c-7-2.12-15.85 2.9-10.43 10"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M523.14 370.77c-6-1-13.15 5.41-7.35 11.79"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M513.47 377.34c-5.41 1.35-11.79 7.54-6.18 12.37M540.73 347c-7.73 3.48-8.51 12.18-4.84 18.56"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M532.61 331c-11.6 4.44-11.41 19.91 1.35 24.74"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M528.55 352.21c-7 4.06-8.31 11.79-3.67 16.82M516.37 325.15c-4.64 1.55-4.25 15.85 8.12 15.46"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M503.61 330c-9.27 6.19 1.94 21.84 17 10.63"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M512.31 344.48c-1.35 6.38.39 13.34 10.63 14.11"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M512.89 353c-7.34 2.71-8.7 17.79 4.64 18.95M489.5 339.26c-9.47 8.7 7.73 16.24 14.11 3.67"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M476.36 353.76c-4.64 5.6 11.6 20.29 18.75-4.26M496.85 349.12c.38 5.8 3.86 9.28 11 9.66M507.67 364.39c-11.4 1.74-15.07 16-2.32 19.14"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M486.6 362.46c-.38 5.41 5.22 9.85 11.6 8.89M504 383.14c-10.44 2.32-11.79 15.85-2.51 15.08"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M496.66 410.78c-8.7-2.61-8.9-12.95-1.17-16.82"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M489.5 401.7c-7.34 4.44-4.44 15.07-.58 16.62s7-.39 7.35-3.67"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M495.69 429.53c.77 5-17.88 3.09-8.31-12.56"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M487.28 430.4c-6.28 9.86 4 17.88 10.44 9.47"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M488.15 442.29c-2.51 7.92 7.05 13.63 13.24 7.44M467.27 368.06c-3.48 7.15 13.92 9.86 15.08-4.83"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M462.44 378.69c-3.48 13.92 22.81 11 16-7"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M479.06 381c3.68 2.13 14.7 2.32 17.4-9.47"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M488.54 381.4c.77 3.67 4.06 8.12 7.15 9.47M476 385.07c-1.16 7.54 6.38 13.73 15.08 13.15"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M477.32 392.42c-4.25 5.8-5.6 17 7.74 17.78"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M457 394.35c-2.13 6 10.44 12.18 17.78 2.32"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M453.16 409.62c-1.06 4.54 10.25 10.63 16.63-8.7"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M464.76 410.78c2.71 4.83 11.79 8.7 17.4-.77"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M473.07 415.81c-2.32 6.76 4.06 13.14 11.79 11.21"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M458.57 414.26c-1.54 9.67 9.67 15.27 16.63 10.25"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M451.23 418.51c-3.29 12.37 12.56 17 18.56 7.73"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M465.73 429.92c.58 7 11.4 12.95 19.91 7.15M446.4 435.72c-.78 3.09 12.17 6.18 14.11-4.64"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M453.94 438.42c3.09 7.93 13.53 9.86 19.52.2"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M470 442.48c1.35 7.35 10.82 11.41 19.14 6.38M492.6 451.76c-2.13 9.86 8.11 17.78 14.49 12.37"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M476.16 450c-3.09 10.83 10.44 17 18 11"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M459.93 444.61c-.78 10.05 7.15 16 16.23 11.6"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M442.72 445.57c-2.7 6.58 11.6 12 18.37 6.38"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M433.83 463.55c3.68 4.25 16.43 0 17.59-9.47"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M447.94 461c4.64 5.41 15.66 8.31 20.11-3.29"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M464.18 463.75c-.19 8.31 14.69 14.3 19.52-1M501.2 465.78c-1.36 4.06 1.83 10.53 8.5 11.3"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M488.92 463.26c-1 4.64 5.8 11.12 12.95 8.51M503.23 473.7c-1.94 5-.29 12.27 6.47 12.18"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M503.9 483.08c-5 4.25-2.9 11.79 4.35 12.08"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M501.29 490.23c-7.15 4.83-4.63 15.46 4.84 14.88M479.64 469.74c0 10.44 13 12 15.47 2.32"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M490.08 478.24c-1.93 6.19 3.1 12.18 11 10.44M491.63 552.86c1.74 2.51 8.89-1.74 7-6s-9.51-2-8.7 2.51"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M496.85 545.13c1-8.51-9.09-9.86-11.6-2.52"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M488.92 538.36c2.52-4.25-6-10.05-9.47-3.87"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M482.54 532c2.32-6.19-7.34-8.89-8.11-3.29"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M472.3 520.57c1.16-3.09 12-1.16 7.34 5.22M488 533.53c4.25-3.87-2.9-11.8-7.35-8.89M516.57 545.32c-3.39.39-6.87 2.61-4.36 9.76 1.75 5 9.19 5.22 10.25 2.22"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M511.63 548.89c-3.28-2.12-10.43 1.45-7.15 8.41 2.48 5.24 8.7 3.09 9.67.39M493.18 558.85c1.64 2.9 9.85 1.65 11.3-1.55"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M498.78 549.28c1.74-1.16 4.93.29 5.61 1.74M498.2 501.63c-5.6 3.67-2.13 14.89 6.57 12"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M496.46 510.72c-4.44 3.47-.39 14.3 7.93 10.24"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M497.81 521c-3.09 3.1-.09 11.7 7.93 10.06"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M496.66 525.22c-1.74-.78-6.29-.2-8.22 2.7M491.63 486.07c-4.25 4.06-2.22 12.37 5.7 13.05"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M490.08 494.58c-6.09 3-6.09 15.07 6.09 15.56"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M489.6 508.21c-3.38 2.7-1.74 13.14 7 11.78"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M492.4 519.61a5.29 5.29 0 0 0-.38 5.8M488.54 515.65c-3.1.09-7.16 2.32-8.22 5.5"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M474.71 509.94c1.16-3.09 10.73-2.89 11.41 6.19"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M487.09 505.3a6.25 6.25 0 0 0-4.64 4.16M482.93 477c-4.16 3.77-6.18 15.65 6.48 18M474.52 501.54c0-3.2 8.6-5.9 11.6-1.16"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M469 484.23c1.26 2.42 7.25 5.71 10.92 3M437.89 465.29a9.53 9.53 0 0 0 10.83 9.86c6.38-.77 7.73-6.38 5.8-10M449.68 475.34c-4.25 5.22 1 12.57 5.8 10.44"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M454.52 471.67c2.51-1 10.82-2.13 13.33 1.74M427.65 473.22c-1.94 2.9 10.05 5.8 14.11.19"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M437.7 476.31c-.39 3.87 1.54 10.44 11.4 7.73"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M450.65 490c1.55-3.28-5.8-8.69-11.41-2.7s.78 12.76 4.26 10.43M424.94 477.08c-2.9 5 8.31 14.21 14.69 5.71"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M417.5 485.78c-4.06 4.16 1 11.79 7.05 9.47s5.51-8.7 4.06-10.34"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M409.67 493.51c-3.29 3-.1 10.05 4.45 10.05s7.34-3.57 6.47-8.11M428.13 492.93c-.58 4.45 6 7.54 10.24 3.39M438.57 488.2a2.94 2.94 0 0 0-.87-3.39"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M402.61 499.51c-3.76 3 4.35 11.3 9.48 3.67M431.71 497.86c-2.42 2.32 1.44 8.41 5.31 6.57"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M418.46 502.12c.58 4.15 8.7 7.24 13.83.87"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M422.91 506.27c-1.26 2.61 1.26 6.77 4.35 6.19M499.84 530.15c-3 5.89 6.58 12.75 13.53 5.6"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M506.8 538.94c-1.45 3.19.29 7.64 2.9 9.28"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M497.72 545.61c.67-2.9 4.83-5.61 8.6-4.25M492.69 538c.58-2.61 4.06-5.22 6.67-4.54M720.3 417.35c-13.72.2-7.92 22.23 3.87 17.79"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M715.86 433.59c-2.71 4.45 2.51 11.5 8.31 7.35"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M722.62 441.81c-4.06 6.76 10.44 17.1 16.24 6.47"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M734.22 452.34c.19 6.38 18.75 10.44 16-2.32"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M748.53 457c4.44 7.54 21.06 8.31 19.32-2.9"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M764.18 461.81c3.48 5 19.72 8.12 19.14-2.32M698.27 398.22c2.31 6 10.24 8.12 18.94 4.64M693.24 402.47c5.41 3.48-2.51 19.33-10.82 12.95"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M693.24 412.33c6 2.9 13.34.77 15.46-7.73"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M705 411.17c.58 4.44 7 7.92 15.27 6.18M690.15 415.81c7.73 6.57-3.48 20.1-8.51 13.91"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M693.05 420.83c3.67 2.71 13.14 1.16 14.11-6"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M702.91 420.83c.77 4.64 4.44 6.38 9.66 6.58"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M690.92 427.21c3.87 5.41 13.53 7 17.78-.19"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M704.45 431.08c-.38 5.22 5.42 9.47 11.41 8.31M683.38 442.68c5 2.51 10.44-7 6.19-13.54"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M689.18 452.73c6 .38 6.77-8.7 1.16-13.73"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M702.91 461c5-1.16 3.47-12.18-8.7-13.15"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M718.18 469.16c4.83-1.36 1-13.53-12.37-12.76"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M736.54 473.41c3.28-5-7.54-13.53-16.43-9.08"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M745.62 480.37c6 1.74 10.06-14.11-8.89-11.6"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M756.64 480.37c5.22-1.35 8.9-10.83-6.37-7.73"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M768.24 481.14c4.64 2.32 6.77-11.21-7.35-7.54M690.34 439c5.8 3.29 14.89-.58 14.11-7.92"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M702.13 437.46c1.94 3.48 1.16 10.24-2.51 12"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M702.71 445.57c3.87 1.55 9.09.2 12.18-6"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M709.48 445.57c1.16 2.71 1.55 8.12-1 10.83"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M710.45 450.21c4.25 2.32 9.27-.77 11.4-5.22"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M719.14 448.86c3.09 1.93 5.8 11 .58 14.69"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M722.62 459.3c3.68.19 9.09.19 12.57-4.45"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M732.68 457.37c3.28 1 7.14 6.38 5.79 11.21"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M738.66 466.84c3.68-.39 10.06-2.9 11.8-7.35"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M748.72 462.39a10 10 0 0 1 4.83 9.67M753.55 469c3.67-.19 7-2.12 7.92-6.18"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M760.51 465.48c2.7 1 6 4.06 6.19 7.74"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M766.31 470.9c2.7-.39 4.64-2.13 6.38-4.84M780 465.68c3.48 3.48-1.15 15.08-8.31 12.95M705.81 231.4c-7.16 4.25-27.46 2.9-17.4-13.92"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M707.74 220c-14.11 5.61-31.51-5.21-13.34-17"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M689.57 199.12c-11.8 0-19.72 18.94-3.87 25.51M643.76 207c-3.09 6 7.92 12.57 15.46 6.58 5.84-4.65 5.41-17.21 1.93-22"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M637.76 221.35c-3.86 12.75 24.55 13.53 20.11-6.77"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M636.22 240.29c1 9.67 27.26 6.57 18.74-12.95M658.06 221.93c2.13 2.9 7.93 7.92 17.78 7M662.7 208.2c.87 3.48 6.76 6.19 14.3 3.58M398.94 502.31c-6.67 4.74 3.58 12.18 7.35 4"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M393.72 506c-6.67 4.74 3.58 12.18 7.35 4"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M388.21 509.56c-6.67 4.74 3.58 12.17 7.35 4"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M382.41 512.84c-6.37 3.39 1.07 11.7 7.54 4.35"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M376.13 516c-6.38 3.37 1.07 11.69 7.54 4.34M408.51 506.08c-.1 4.93 9.28 7 12.66-.39"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M414.41 510.62c-2.9 3.68 2.41 8.22 5.31 6.57"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M401.94 509.94c-.29 4.16 7.83 6.58 11.79 2"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M406.38 514.3c-2.61 3.38 2.52 7.92 5.8 6.56"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M396.53 513.71c.28 3.29 4.92 7.06 10 4.93"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M399.52 518.16c-1.93 1.74-1 5.8 1.74 7.06"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M389.47 517.87c-.77 3 4.35 8.31 9.57 4.83"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M390.53 521.35c-3.09 2.42-2.7 6.09 1.26 6.57"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M383.09 521c-.39 2 2.22 5.32 5.51 4.93M366.56 520.77c-3.09 1.64 4.84 10.05 9.76 2.22"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M358.93 524.25c-3.87 1.84 5.7 11.11 9.95 1.64M384 523.86c-3 .68-4.93 5-2.42 6.77"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M374.2 525.41c-.39 1.74 3.28 4.64 6.28 3.57M371.69 526.18c-2.9 1.84-1.36 7 2 6.19M361.35 529.56c-2.71 2-.88 6.09 2.89 5.13"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M366.27 529.27c.1 1.07 2.52 2.71 4.55 2M352 527.53c-3.38 1.45-3.19 10 8.22 5.32"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M344.33 530.92c-4.73 2.32-3.19 8.7 7.16 2.61M352.36 534c-1.26 1-2.61 5.22 2.12 3.58"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M343.66 536c-1.94 1.74-.68 5.32 3.57 4M333.7 536.62c-3.48 2 4.16 4.74 9.28-.68"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M336 539.13c-1.54 1.55-1.54 6.09 2.52 4.45"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M326.16 541c-2.32 1.74 1.65 4.06 8.9.87"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M329.06 543.48c-2.7 2.23-2.41 5 1.55 4.16"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M321 544.74c-3 2.71 1.35 4.54 6.57 2.32"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M321.14 547.74c-5.12 2.31-2.9 6.57.29 4.92M492.21 562.52c-1.19 2.56 2.71 4.64 6.38 4.06s6.9-3.46 4.25-7.54"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M503 564.07c3.48 2.7 9.67-.39 9.67-4.45"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M716.24 154.47c-15.46-7.74-47.55-22-56.63-10.44 8.31-3.48 32.66.19 52.77 18.75Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M725.62 153.65c-17.88-20.83-28.41-16.17-41.27-23.35-12.08-6.74-31.32-8.12-35 2.61 17.64-8.6 33.84 4.62 43.79 6.22 13.67 2.19 21.39 12.76 25.39 17.62ZM793 151c-9.28-21.27-29.12-15.71-37.89-24.75-12.75-13.14-45-25.32-58.37-16.23 29.38-1.55 41.89 20.25 57.6 27.83 11.2 5.4 23.18 17 38.66 13.15Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M758.19 148.67C742.34 129 718 111.55 706.77 118.13c14.69.77 19.33 11 29.77 17.59s5.8 16.04 21.65 12.95ZM682.8 183.46c-16.62-6.19-49.09-9.28-64.17 9.67 25.13 4.25 63.01 1.93 64.17-9.67Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M679.71 190.81c-16.63-7.74-29.61 3.06-45.23 1.54-29.77-2.9-51-1.16-53.74 13.15 17-15.27 45.62-2.71 57.22-5.8s54.51-.39 68 5.41c-6.96-8.51-17.74-10.82-26.25-14.3ZM731.9 146.54c-3.86-12.76-3.67-26.29 15.46-25.32-4.83-6-22.61-9.09-25.51 13.34-21.07-15.47-44.08-18.17-48.32-4.84 10.82-9.28 27.63-2.51 47.74 20.3a35.6 35.6 0 0 1 10.63-3.48Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M702.91 164.13c-12-7.73-28.23-20.3.19-25.32-12.18-6.57-30-3.67-28 18.75-32.47-13.15-55.79-8.71-60.7 4.25C609 176.12 629.07 184 632.55 175c-3.68 1.54-16.24-2.71-9.67-10.83s40.25-2 72.3 14.69c8.89 4.6 39.43 3.83 7.73-14.73Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M694.4 185.39c-9.25-18.88-39.24-1.74-45.28-20-8.26 26.77 42.65 11.94 45.28 20ZM885.19 205.88c6.29 3.13 11.73-1.78 2.11-5.64 6.29 3.13 11.78-1.67 2.16-5.52 6.29 3.12 11.78-1.68 2.16-5.53-2.57 2.58-6.24 12.05-6.43 16.69ZM888.47 169.54c13.92-14.69-1.15-19.71 15.85-34.79 13.92-12.34 2.66-20.56 15.86-30.16 4.25-3.09 13.53-9.27 14.3-15.46 5.61 13.92-17.4 15.85-15.85 38.27 1 14.28-8.67 13-12.37 37.12-.78 5.02-4.26 16.23-17.79 5.02Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M894.66 176.12c7.73-16.63 16.61-16.31 20.87-22.81 8.12-12.38 25.33 2.12 39.82-8.9-2.51 15.66-22 10.06-30.53 20.11s-15.47 14.69-30.16 11.6Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M896.59 181.53c13.54-10.83 23.51-3.61 32.86-9.28 23.58-14.31 33.06 2.9 54.13-3.87-5.61 13.53-36.73 1.94-50.26 12s-61.08 19.7-36.73 1.15ZM857.16 258.65c-.19-6.18-6-14.11-14.11-15.07s-11.6-9.48-17.78-9.86S815 221 806.51 221.15s-12 11.22 7.93 21.27 41.95 21.65 42.72 16.23ZM832 263.87c-8.51.39-9.67 12.76-17.78 13.15 11.21 6 19.33-2.71 25.12-10.44Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M839 265.42c-7.35 6.19-9.47 19.14 1.16 22.81-6.38-8.8 11.21-12.76 5.8-20.88Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M846.33 265.81c-5.79 11.21 9.09 12.56 5.22 21.07 8.51-1.94 9.86-18 2.13-22.23Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M789.5 241.84c13.92-.78 26.65 6.75 35.19 18.94 5.41 7.73 23.58 10.83 29.76 4.64s2.71-19.33-12.75-15.08c-3.87-6.57-15.08-4.25-20.49-9.66s-26.29-20.88-31.71 1.16Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M841.7 250.34c-3.68.78-4.84 7.15-2.52 10.44M849.62 254.21c1.16 1.93.39 4.64-.19 6M811.54 242.42c7.15.38 8.51 5.6 16.24 7.54"
        className="Bhutan_svg__cls-7"
      />
      <path
        d="M806.82 224.83c24.7 6.18 44.3 11.59 56.45 18.55s31 8.9 47.44 4.26 48.21-8.9 46.65 11.59C966 249 955 238 933.05 236c.4-10-10.36-19.14-18.1-13.15 7.16-1 13.33 12.38-.78 17.79 2.75-10.05-7.25-19.14-17.64-14.69 6.67 1.93 13.41 13.11-1.5 17.39-9.42 2.71-23.13-.77-33.33-7s-67.42-28.52-54.88-11.51Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M869.14 214.78c-7.73 3.47-2.7 11.59-14.69 16.23s-20.29 15.27-17.59 24.36c8.12-17.79 22.43-17 27.45-24s12.37-17.17 4.83-16.59Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M871.27 215.93c-.38 14.12-11.49 9-7.15 28.81 1.35 6.18 3.86 16.23-.39 26.29 12.47-9.09 4.45-28.18 10-35.38 2.71-3.48 6.19-8.89 7.54-13.53-2.9 8.12-2.7 23.2 5.22 27.06-6.38-15.08 17.21-27.45 1-44.84-2.3 4.25-9.65 11.79-16.22 11.59ZM831.83 201.82c1.94 2.9 3.87 10.25 2.13 14.31 3.87-2.32 9.48-8.31 11.21-12.37 7.93 1.16 11 11 3.49 15.27 4.63 0 12.56 0 17-5.22-5.41-5.99-22.22-15.27-33.83-11.99Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M711.6 174.09c-1.25-1.14-3.36-2.22-7.15-3-11.7-2.4-5.66-13 4.3-12.86C730 135 742 152.92 767.85 145.57c9.07-2.57 15.29-1.81 20.23.33 11.6-7.73 25.2-5.57 35.06 3.51a7.92 7.92 0 0 1 4.64-3.64c9.08-2.53 16.42 5.22 18.93 15.27 7.08-1.31 15.17 2.19 20.49 7 7.36-3.78 12.44-3.95 14.3-.06 6.58-3.09 15.09-5 19.34 5.41s-10.05 7.34-12.37 29.38c-1.43 13.59-16.62 18.94-28.61 10.83-19.17-13-37.88-15.08-47.16 4.63s-16.55 31.2-39.05 24.77c-8.11-2.32-18.56.77-25.12 9.66s-16.63.58-28.61 1.55c15.07-2.32 9.3-6.11 22.42-7 12-.77 8.89-12 16.62-13.53-30.15 7.73-29-3.48-53.73 4.25 10.82-13.92 27.83-6.18 36.34-14.3-22.43-.39-32.46-15-42.53-8.89-15.85 9.66-8.9 37.18-50.26 34.79-20.1-1.16-32.86 1.55-44.84 13.53 20.88-43.3 49.27-19.51 63-33.25 8.12-8.12 14.31-14.3 18.56-22a9.15 9.15 0 0 1 6-4.88c-34.34-10.82-13.5-27.68 20.1-28.84Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M881.49 168a9.65 9.65 0 0 1 .8 4.24c0 8.5-12.76 8.89-13.53 21.46-.41 6.57-1.16 10.24-5.61 9.47s-8.31-7.73-4.06-15.85"
        className="Bhutan_svg__cls-7"
      />
      <path
        d="M718 161.42a16.37 16.37 0 0 0-9.28-3.19M788 145.84c10.24 4.43 15.23 15.06 30.1 15.58 14.32.51 23.2 21.27 47.17 7.74.65-.37 1.28-.71 1.9-1"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M823.14 149.41c-2.13 3.4-2.62 8.14-2 12.3M776.36 193.13c-18.17 0-22.81 9.27-22.81 18.17s8.5 20.49 23.58 20.49 23.2-9.28 23.2-19.33-9.28-19.33-23.97-19.33Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M779.65 231.4c-.39-5-9.48-4.25-9.09-8.12s5-5.41 5-10.82 8.11-5.8 10.82-1.55 10.83 12.56 12.57 8.31"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M786.41 210.91a14.87 14.87 0 0 0-.58 19.72M792.21 217.48c-1.35 2.9-1.74 7.35-.19 10.05"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M864.41 203.27c14.21 1.16 16.62-14.49 6-15.46M846.91 161c-4.92-6.28-16.23-8.41-16.43 4.93"
        className="Bhutan_svg__cls-4"
      />
      <path
        d="M829.13 181.14c-4.83-12-17.2-13.72-23.78-7.73-5.47 5-5.6 18 6.19 20.68 4.06-4.83 11.98-11.21 17.59-12.95Z"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M823.81 173.6c-7-6.18-17.2 5.51-7.92 16.24"
        className="Bhutan_svg__cls-3"
      />
      <path d="M846.91 161c-4.25-4.54-13.52-1-10.92 8.21 2.01-4.21 6.38-7.79 10.92-8.21M820.64 185.8a31.8 31.8 0 0 1 8.49-4.66 18.7 18.7 0 0 0-5.71-7.85c-2.21-1.52-8.57 7.02-2.78 12.51" />
      <path
        d="M809.22 170.12c-7-4.64-13.34-4.25-15.47-.38-5-.2-9.18 3.48-9.37 10.82"
        className="Bhutan_svg__cls-5"
      />
      <path
        d="M795.11 183.65c-8.31-5.7-19.72-3.57-18.94 9.19M771.14 200.08c4.06-3.28 9.86-5.6 14.3.2M833.19 187.52c-1.55 2.13-2.71 5.41-.19 10.44-3.1-4.06-10.83-4.06-19.14 6.76M851.55 186.94c-10 1.16-9.85 7.73-1.74 10.63M780 162.39c-8.5-1.74-14.69 3.29-2.9 7.54M796.27 156.59c-12-2.9-16.82.2-11.41 2.9M761.67 204.72c-.39 4.26 1.93 9.86 8.89 3.48M764 217.48a5.57 5.57 0 0 1-1 3.48M736.15 160.84c-7.34-2.12-8.69-8.89-.19-8.31M733.64 176.5c-8.12-2.7-8.12-10.63-1.36-9.86M748.72 172.44c-9.48-2.32-9.86-8.89-2.71-7.92M749.88 152.34c-5-.39-12.76 5.22.19 8.5M764 163.55c-11.79-1.74-11.6 3.09-4.64 6.19M772.88 152.34c-9.08-1.74-12.18 3.67-6 6M744.27 185.78c-2.22-1.84-4-10.63 6.57-8M766.31 183.07c-7.15-1.93-13.92 5-7.35 9.09M775.78 174.76c-7.54-1.35-13.92.78-9.86 3.48"
        className="Bhutan_svg__cls-5"
      />
      <path
        d="M691.43 202.89c4.66-1.1 11.47 1.17 21.91 6.09 6.58 3.09 26.29 9.66 38.66 3.09-12.76 4.64-22.42-14.69-32.08-12.37s-27.36 5.89-34.8-1.16c18.17 1.16 27.94-13.24 48.71-.78 5.8 3.48 13.15 5.8 19.72 5.42-17-20.49-39.43-7.35-41.75-24 10.24 11 35.27-2.52 48 18.17M846.51 161a14.4 14.4 0 0 0-10.51 8.25"
        className="Bhutan_svg__cls-3"
      />
      <path
        d="M715.47 182.29c-2.39-3-1.31-5.94-3.87-8.29"
        className="Bhutan_svg__cls-3"
      />
    </g>
  </svg>
);
export default SvgBhutan;
